import {getCustomerId, getIsMachineHealthDetailsAvailable} from './selectors';

import {getAPICall} from '../../services/apiCallsHandler';
import {
  GET_MACHINE_HEALTH_DETAILS,
  LOAD_MACHINE_HEALTH_DETAILS,
} from '../actions';

import {call, put, select, takeEvery} from 'redux-saga/effects';

export function* loadMachineHealthDetails() {
  const isMachineHealthDetailsAvailable = yield select(
    getIsMachineHealthDetailsAvailable
  );

  if (isMachineHealthDetailsAvailable) {
    return;
  }

  const customerId = yield select(getCustomerId);

  const machineHealthDetails = yield call(
    getAPICall,
    'getCustomerMachineHealth?customerId=' + customerId,
    {
      isCallBack: false,
      errorTag: 'GET_CUSTOMER_MACHINE_HEALTH',
      logInfoMsg: 'invoke customer machine health',
      redirectToOops: false,
    },
    {}
  );

  yield put({
    type: GET_MACHINE_HEALTH_DETAILS,
    machineHealthDetails,
  });
}

export function* machineHealthWatcher() {
  yield takeEvery(LOAD_MACHINE_HEALTH_DETAILS, loadMachineHealthDetails);
}
